// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"19116a77","239":"2c2b09f8","396":"a396c506","455":"3c0d23ec","857":"7594d810","977":"30e503f7"}[chunkId] + ".chunk.js";
};